// @ts-nocheck
import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { listKnowledgeBases, getKnowledgeBaseStatus } from '@/service/knowledgeBaseApi';
import HeadingInfo from './HeadingInfo';

function pick(obj: any, keys: string[], fallback: any = null) {
  for (const key of keys) {
    if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== '') return obj[key];
  }
  return fallback;
}
const kbId = (row: any) => pick(row, ['id', 'knowledge_base_id', 'kb_id'], '');
const kbName = (row: any) => pick(row, ['name', 'kb_name'], 'Untitled');
const kbStatus = (row: any) => pick(row, ['overall_status', 'status', 'ingestion_status'], null);


const READY_STATUSES = new Set(['completed', 'ready', 'success']);
const isSelectable = (row: any) => READY_STATUSES.has(String(kbStatus(row) || '').toLowerCase());

export default function KnowledgeBaseCard({ value, onChange }: any) {
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    listKnowledgeBases()
      .then((resp: any) => {
        const list = Array.isArray(resp) ? resp : [];
        if (cancelled) return;
        setOptions(list);
        list.forEach((row) => {
          const id = kbId(row);
          if (!id) return;
          getKnowledgeBaseStatus(id)
            .then((statusResp: any) => {
              const nextStatus = pick(statusResp, ['overall_status', 'status'], undefined);
              if (nextStatus === undefined || cancelled) return;
              setOptions((prev) =>
                prev.map((r) => (kbId(r) === id ? { ...r, overall_status: nextStatus } : r)),
              );
            })
            .catch(() => {});
        });
      })
      .catch(() => setOptions([]))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const selectableOptions = options.filter(isSelectable);
  const hiddenCount = options.length - selectableOptions.length;

  return (
    <Card>
      <CardHeader className="space-y-0">
        <CardTitle className="flex items-center gap-1.5 text-base">
          Knowledge Base<span className="text-destructive">*</span>
          <HeadingInfo text="Links a knowledge base of uploaded docs or FAQs that the agent can answer questions from." />
        </CardTitle>
      </CardHeader>
      <CardContent>
        {selectableOptions.length === 0 && !loading ? (
          <p className="py-6 text-center text-sm text-muted-foreground">
            {options.length === 0
              ? 'No knowledge bases created yet.'
              : 'No knowledge base is ready yet — wait for processing to complete.'}
          </p>
        ) : (
          <>
            <Select value={value || undefined} onValueChange={onChange} disabled={loading}>
              <SelectTrigger>
                <SelectValue placeholder={loading ? 'Loading knowledge bases…' : 'Select a knowledge base'} />
              </SelectTrigger>
              <SelectContent>
                {selectableOptions.map((opt) => (
                  <SelectItem key={kbId(opt)} value={kbId(opt)}>
                    {kbName(opt)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {hiddenCount > 0 && (
              <p className="mt-1.5 text-xs text-muted-foreground">
                {hiddenCount} knowledge base{hiddenCount > 1 ? 's are' : ' is'} still processing and hidden until ready.
              </p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}